import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div className="min-h-screen flex flex-col justify-center items-center bg-gray-50 text-gray-800 px-6">
      <h1 className="text-6xl font-bold text-accent mb-4">404</h1>
      <h2 className="text-2xl font-semibold mb-2">Page Not Found</h2>
      <p className="text-center text-gray-600 max-w-md mb-6">
        Oops! The page you're looking for doesn't exist, was removed, or is temporarily unavailable.
      </p>
      <Link
        to="/"
        className="bg-accent text-white px-6 py-3 rounded-lg font-medium hover:bg-blue-700 transition"
      >
        Back to Home
      </Link>
    </div>
  );
};

export default NotFound;
